export const GET_LMIMAGES_API_REQUEST = "GET_LMIMAGES_API_REQUEST";
export const GET_LMIMAGES_API_SUCCESS = "GET_LMIMAGES_API_SUCCESS";
export const GET_LMIMAGES_API_ERROR = "GET_LMIMAGES_API_ERROR";

export const POST_LMIMAGES_API_REQUEST = "POST_LMIMAGES_API_REQUEST";
export const POST_LMIMAGES_API_SUCCESS = "POST_LMIMAGES_API_SUCCESS";
export const POST_LMIMAGES_API_ERROR = "POST_LMIMAGES_API_ERROR";

